<template>
  <div>
    <Cargando v-if="!usuario" />
    <div v-else>
      <div class="flex items-center gap-4 md:gap-2 mb-2 pb-2">
        <div class="w-[2.5rem] h-[2.5rem] md:w-[4rem] md:h-[4rem] rounded-full overflow-hidden aspect-square">
            <img v-if="usuario.urlImagen" :src="usuario.urlImagen + '?t=' + new Date().getTime()" alt="" class="w-full h-full object-cover border-1 border-gray-200" />
        </div>
        <h2 class="md:text-xl text-black font-medium text-lg overflow-ellipsis md:overflow-visible">
          {{ usuario.nombre }} {{ usuario.apellido }}
        </h2>
      </div>
      <hr class="border-t border-gray-200 mb-2 md:hidden" />

      <FormKit type="form" @submit="submitHandler" v-model="extra" :classes="{ outer: 'col-span-2' }">
        <div class="grid grid-cols-1 md:grid-cols-1 gap-x-4">
          <!-- Instagram -->
          <div class="flex items-center space-x-2">
            <FormKit type="text" name="instagram" placeholder="@usuario" label="Instagram"
              :classes="{ outer: 'col-span-2 text-gray-800 font-medium' }" prefixIcon="instagram" />
          </div>
          <!-- Twitter -->
          <div class="flex items-center space-x-2">
            <FormKit type="text" name="twitter" placeholder="@usuario" label="Twitter"
              :classes="{ outer: 'col-span-2 text-gray-800 font-medium' }" prefixIcon="twitter" />
          </div>
          <!-- WhatsApp -->
          <div class="flex items-center space-x-2">
            <FormKit type="checkbox" label="Compartir mi Whatsapp" name="compartirTelefono"
              help="Se mostrará un icono de WhatsApp en tu perfil" :value="true" :classes="{
                outer: 'col-span-2 text-gray-800 font-medium',
                input: 'h-5 w-5 text-blue-600',
              }" />
          </div>
          <!-- Compartir mis datos -->
          <div class="flex items-center space-x-2">
            <FormKit type="checkbox" label="Ocultar mis datos" name="ocultarDatos"
              help="Ocultaremos tu perfil de la comunidad" :value="true" :classes="{
                outer: 'col-span-2 text-gray-800 font-medium',
                input: 'h-5 w-5 text-blue-600',
              }" />
          </div>
        </div>
        <template #submit>
          <div class="flex justify-end">
            <FormKit type="submit" :classes="{
              outer: 'flex justify-end w-full !mb-0',
              input: '!bg-black !text-white font-semibold px-6 py-2 rounded-md !border-none !mb-0',
            }" label="Guardar" />
          </div>
        </template>
      </FormKit>
    </div>
  </div>

</template>


<script setup>
import { onMounted, ref } from 'vue';
import { actualizar, miUsuario } from '@/services/usuarios';
import { faker } from "@faker-js/faker";
import { notify } from "notiwind";
import Cargando from '../escuela/Cargando.vue';
// Modelo de usuario extra
const extra = ref({
  instagram: '',
  twitter: '',
  compartirTelefono: false,
  ocultarDatos: false,
});

const usuario = ref(null);

onMounted(async () => {
  // Cargar los datos del usuario
  const usuarioActualizado = await miUsuario();
  if (!usuarioActualizado) {
    usuario.value = {
      nombre: faker.name.firstName(),
      apellido: faker.name.lastName(),
      email: faker.internet.email(),
      telefono: faker.phone.number({ style: "international" }),
      provincia: faker.address.state(),
      pais: faker.address.country(),
      urlImagen: faker.image.avatar(),
      idSocio: faker.number.int({ min: 100000, max: 999999 }),
    };
    return;
  }
  console.log(usuarioActualizado);
  usuario.value = usuarioActualizado;
  extra.value = usuarioActualizado.extra;
});

// Manejador del envío del formulario
const submitHandler = async (data) => {
  const nuevoExtra = {
    extra: {
      ...extra.value,
      ...data
    }
  }

  await actualizar(nuevoExtra)
  notify({ group: "foo", title: "¡Listo!", type: "success", text: "Tus datos se guardaron correctamente" });
};
</script>
<style>
.overflow-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>